import Route from '@ember/routing/route'

/**
 * If anything goes wrong during csv validation/import, the other routes will
 * replace the current route with this error route and pass in the rollbar uuid as
 * the model to this route.
 */
export default class ErrorRoute extends Route {
  buildRouteInfoMetadata() {
    return {
      hideFooter: true,
    }
  }

  model({ uuid }: { uuid: string }) {
    return { uuid }
  }
}
